module.exports = __webpack_public_path__ + "static/media/F115A6DA-74C9-4FCB-94E5-0FE360A7C592.f0f65617.JPG";